import React from "react"
import PropTypes from "prop-types"

const ShopifyThemesTextSection = ({ title, text, buttonText, buttonUrl }) => {
  return (
    <section className="section-text">
      <div className="section-text__container container container--products-landing">
        <h1 className="section-text__title">{title}</h1>

        <p className="section-text__text">{text}</p>

        <a
          className="section-text__button button button--products-landing button--primary button--big"
          href={buttonUrl}
        >
          {buttonText}
        </a>
      </div>
    </section>
  )
}

ShopifyThemesTextSection.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
}

export default ShopifyThemesTextSection
